import styles from '@styles/Footer/main.module.scss';
import React from 'react';
import { useNavigation } from 'services/hooks/queries/useNavigation';
import Address from './Address';
import Copyright from './Copyright';
import { footerNavGroups } from './footerNavGroups';
import Header from './Header';
import OtherMenu from './OtherMenu';

const Footer: React.FC = () => {
  // const { data } = useNavigation({ navigationIdOrSlug: '2' });

  return (
    <footer className={styles.container}>
      <Header />

      <div className={styles.container__menu}>
        {footerNavGroups.length > 0 &&
          footerNavGroups.map((navGroup, index) => {
            const showMoreLink = {
              text: 'View all',
              url: navGroup.path,
            };
            const hasShowMoreLink = navGroup.items && navGroup.items.length > 0 && navGroup.path;

            return (
              <OtherMenu
                key={index}
                menuItems={navGroup}
                title={navGroup.title}
                showMoreLink={hasShowMoreLink && showMoreLink}
              />
            );
          })}
      </div>

      <Address />

      <Copyright />
    </footer>
  );
};

export default Footer;
